<app-graph
  [data]="data()"
  [options]="{ maintainAspectRatio: false, plugins: { legend: { display: false } } }"
  type="line"
/>
